const scrollToId = (id) => {
  if (!id) return;
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const AboutHeroSection = ({ title, subTitle, backgroundColorClass, items = [] }) => {
  return (
    <div className="container main-section">
      <div className="responsive-main-section">
        <div className={`title-section ${backgroundColorClass || ""}`}>
          <div className="title-link">
            <div className="title font-amaticsc-bold">{title}</div>
            <div className="sub-title font-zenkurenaido">{subTitle}</div>
          </div>
        </div>
        <div className="content-section">
          {items.map((item, i) => (
            <div
              key={item._key || i}
              className="content-item"
              onClick={() => scrollToId(item.targetId)}
              style={{ cursor: "pointer" }}
            >
              <div className="item-title font-amaticsc-bold">
                {item.titleEN}
                {item.titleENSuffix && (
                  <>
                    {" "}
                    <span className="font-zenkurenaido">{item.titleENSuffix}</span>
                  </>
                )}
              </div>
              <p className="item-sub-title font-zenkurenaido">{item.titleJP}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AboutHeroSection;
